export default __webpack_public_path__ + "static/media/market-cocoon-image.0383923a.png";